import React from "react";
import SendIcon from "@mui/icons-material/Send";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import { PublishEventPage } from "../tools/publish-event/PublishEventPage";
import { EmailQueuePage } from "../tools/email-queue/EmailQueuePage";
import { SuggestAToolPage } from "../tools/suggest-a-tool/SuggestAToolPage";

export interface ToolDefinition {
  id: string;
  path: string;
  label: string;
  icon: React.ReactNode;
  status: "available" | "comingSoon";
  element: React.ReactNode;
}

/**
 * Single source of truth for "what tools does this app have". Tools are
 * standalone and unrelated to one another - each brings its own connection
 * concept, data source, and shape. Add a tool by adding an entry here - the
 * sidebar nav and the routes are both generated from this list.
 */
export const toolRegistry: ToolDefinition[] = [
  {
    id: "publish-event",
    path: "/publish-event",
    label: "Publish Event",
    icon: <SendIcon fontSize="small" />,
    status: "available",
    element: <PublishEventPage />,
  },
  {
    id: "email-queue",
    path: "/email-queue",
    label: "Email Queue",
    icon: <MailOutlineIcon fontSize="small" />,
    status: "available",
    element: <EmailQueuePage />,
  },
  {
    id: "suggest-a-tool",
    path: "/suggest-a-tool",
    label: "What should we add next?",
    icon: <LightbulbIcon fontSize="small" />,
    status: "available",
    element: <SuggestAToolPage />,
  },
];
